module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAaCAYAAADMp76xAAAABGdBTUEAALGOfPtRkwAAARNJREFUWAnVl8EJwlAQRL+WICh4sZa0YQE26N27BZgKLMECdB78BQ0eZ5efgSXiYf/LZjZDWmvtpXqrjqrhtRXh3Cmn4Wk74EVXJvxU7fp/Q182orupAvqs38PbA8CABpzC23cVT4CbGk5AAQdkLGLAczOrmDr2wNuAAz3kpMX1IxYxoHkCqxCTZsrYJUsnNb6q9o4D8G8soqPfvx7AcsZDZYGORcxaPiCBtUFjB5phjywd1NgGXZWINujKRLRB49+qRLRBVyaifRFZPqbOIka4uBPxG5pXn02ZiYg9gCVcrGLSvPoyE9EKjD0AJmRWo9RE5JvOrbk3nNyNs/pVJaKNvzIRbdAs3zIRbc2zGi0T0XLOB1IBY4rlBQq0AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/scatter-bg-pattern.png
// module id = T3Tp
// module chunks = 7